import type { AlbumVariationView, WAlbumView } from '@zola/svc-web-api-ts-client';
import staticFlags from 'libs/universal/utils/staticFlags';

const getImageUrl = (imageUuid: string) => {
  const env = (typeof window !== 'undefined' && window.zola && window.zola.env) || 'production';
  let hostname = '//images.zola.com';
  if (env === 'development' || env === 'staging') {
    hostname = '//stage-images.zola.com';
  }
  return `${hostname}/${imageUuid}`;
};

export const getAlbumStartingPriceVariationsPerSize = (
  albumStartingPriceVariations: AlbumVariationView[]
) =>
  albumStartingPriceVariations.reduce((list, variation) => {
    if (variation.options) {
      const existingVariationsPerSize = Array.isArray(list[variation.options['book-size']])
        ? list[variation.options['book-size']]
        : [];
      const consolidatedVariationsArray = [...existingVariationsPerSize, ...[variation]].sort(
        (v1, v2) => (v1.price_cents || 0) - (v2.price_cents || 0)
      );
      return {
        ...list,
        ...{
          [variation.options['book-size']]: consolidatedVariationsArray,
        },
      };
    }
    return list;
  }, {} as Record<string, Array<AlbumVariationView>>);

export const mapProductListToSegment = (albumListing: WAlbumView[]) =>
  albumListing.map(album => {
    const {
      uuid,
      default_variation: {
        uuid: defaultVariationUuid = '',
        sku_object_id = '',
        price_cents = 0,
        options: defaultVariationOptions = {},
      } = {},
      name,
      key = '',
      colors = {},
      shot_keys = {},
    } = album;
    const currentAlbumCoverType = defaultVariationOptions['cover-type'];
    const currentAlbumColorUuid = colors[currentAlbumCoverType]?.[0]?.uuid;
    const getImageUuidPerCurrentAlbumColor =
      shot_keys.PDP_FRONT?.find(
        variation =>
          variation.book_size === defaultVariationOptions['book-size'] &&
          variation.color_uuid === currentAlbumColorUuid
      )?.image_uuid || '';
    const productPosition = ['classic', 'premier', 'deluxe'].indexOf(key) + 1;
    if (staticFlags.get('updateSegmentEventsPLV')) {
      return {
        album_uuid: uuid,
        sku: sku_object_id,
        variant_uuid: defaultVariationUuid,
        category: 'photo_albums',
        name,
        brand: `${name} Album`,
        price: price_cents / 100,
        quantity: 1,
        image_url: getImageUrl(getImageUuidPerCurrentAlbumColor),
        position: productPosition,
      };
    }
    return {
      product_id: uuid,
      category: 'photo_albums',
      sku_id: sku_object_id,
      name,
      price: price_cents / 100,
      quantity: 1,
      position: productPosition,
      url: `/wedding-albums/select?album_type=${key}`,
      variant: defaultVariationUuid,
    };
  });

export default getImageUrl;
